import { TaxRulesTable } from './TaxRulesTable'
import { AliquotasTable } from './AliquotasTable'
import { getNCMValidationRules } from '../../utils/ncm-helpers'

// Função para formatar código NCM com máscara 0000.00.00
const formatNCMCode = (e) => {
  // Remove tudo que não é número
  let value = e.target.value.replace(/[^0-9]/g, '')
  
  // Limita a 8 dígitos
  value = value.substring(0, 8)
  
  // Aplica a máscara 0000.00.00
  if (value.length > 4) {
    value = value.substring(0, 4) + '.' + value.substring(4)
  }
  if (value.length > 7) {
    value = value.substring(0, 7) + '.' + value.substring(7)
  }
  
  e.target.value = value
}

// Função para formatar código de exceção (apenas números)
const formatExceptionCode = (e) => {
  e.target.value = e.target.value.replace(/[^0-9]/g, '')
}

export const CreateNCMForm = ({ 
  register,
  formErrors,
  isCreatingNCM = false,
  watch,
  setValue,
  onBackToSearch
}) => {

  return (
    <div className="space-y-6">
      
      {/* Header with back button */}
      <div className="flex justify-between items-center mb-4">
        {onBackToSearch && (
          <button
            type="button"
            onClick={onBackToSearch}
            className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors absolute top-4 right-4"
          >
            <svg className="h-3 w-3 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            Buscar por NCM
          </button>
        )}
      </div>

      {/* Basic NCM fields */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Código NCM {isCreatingNCM && '*'}
          </label>
          <input
            {...register('ncm_code', getNCMValidationRules('ncm_code', isCreatingNCM))}
            placeholder="0000.00.00"
            maxLength={10}
            inputMode="numeric"
            onInput={formatNCMCode}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
          {formErrors.ncm_code && (
            <p className="mt-1 text-sm text-red-600">{formErrors.ncm_code.message}</p>
          )}
        </div>
        <div>
          <div className="flex items-center gap-2 mb-2">
          <label className="block text-sm font-medium text-gray-700">
            Código de Exceção
          </label>
            <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
              Opcional
            </span>
          </div>
          <input
            {...register('exception_code', getNCMValidationRules('exception_code', false))}
            placeholder="001"
            maxLength={3}
            inputMode="numeric"
            onInput={formatExceptionCode}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
          {formErrors.exception_code && (
            <p className="mt-1 text-sm text-red-600">{formErrors.exception_code.message}</p>
          )}
        </div>
      </div>

      {/* Description field - full width */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Descrição {isCreatingNCM && '*'}
        </label>
        <input
          {...register('ncm_description', getNCMValidationRules('ncm_description', isCreatingNCM))}
          placeholder="Descrição do NCM"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
        {formErrors.ncm_description && (
          <p className="mt-1 text-sm text-red-600">{formErrors.ncm_description.message}</p>
        )}
      </div>

      {/* Tax rules table */}
      <TaxRulesTable 
        register={register}
        errors={formErrors}
        isCreatingNCM={isCreatingNCM}
      />

      {/* FCP aliquots by state */}
      <AliquotasTable 
        register={register}
        errors={formErrors}
        watch={watch}
        setValue={setValue}
        isCreatingNCM={isCreatingNCM}
        title="Alíquotas FCP e ICMS Interno"
        description="Defina alíquotas específicas do Fundo de Combate à Pobreza (FCP) e ICMS Interno para estados selecionados. Estados não preenchidos terão valor padrão definidos pelo sistema."
      />
    </div>
  )
} 